/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DownloadCodexInstallScriptSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DownloadCodexInstallScriptRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type DownloadCodexInstallScriptResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type DownloadCodexInstallScriptSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DownloadCodexInstallScriptSecurity$outboundSchema: z.ZodMiniType<
  DownloadCodexInstallScriptSecurity$Outbound,
  DownloadCodexInstallScriptSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function downloadCodexInstallScriptSecurityToJSON(
  downloadCodexInstallScriptSecurity: DownloadCodexInstallScriptSecurity,
): string {
  return JSON.stringify(
    DownloadCodexInstallScriptSecurity$outboundSchema.parse(
      downloadCodexInstallScriptSecurity,
    ),
  );
}

/** @internal */
export type DownloadCodexInstallScriptRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DownloadCodexInstallScriptRequest$outboundSchema: z.ZodMiniType<
  DownloadCodexInstallScriptRequest$Outbound,
  DownloadCodexInstallScriptRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function downloadCodexInstallScriptRequestToJSON(
  downloadCodexInstallScriptRequest: DownloadCodexInstallScriptRequest,
): string {
  return JSON.stringify(
    DownloadCodexInstallScriptRequest$outboundSchema.parse(
      downloadCodexInstallScriptRequest,
    ),
  );
}

/** @internal */
export const DownloadCodexInstallScriptResponse$inboundSchema: z.ZodMiniType<
  DownloadCodexInstallScriptResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function downloadCodexInstallScriptResponseFromJSON(
  jsonString: string,
): SafeParseResult<DownloadCodexInstallScriptResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DownloadCodexInstallScriptResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DownloadCodexInstallScriptResponse' from JSON`,
  );
}
